module.exports = __webpack_public_path__ + "img/deploy-it.jpg_w545.72f18899.jpg";